var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid",attrs:{"src":"/img/widgets/giftcard_buybox.png"}})])
}]

export { render, staticRenderFns }